import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const claimHistorySlice = createSlice({
  name: "claimHistory",

  initialState: { claimHistory: [], claim_ticketHistoryLoader: false },
  reducers: {
    setAllClaimHistory: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.claimHistory = payload;
    },
    setClaimTicketLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.claim_ticketHistoryLoader = payload;
    },
    resetAllClaimHistory: (state) => {
      state.claimHistory = [];
    },
  },
});

export const {
  setAllClaimHistory,
  resetAllClaimHistory,
  setClaimTicketLoader,
} = claimHistorySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default claimHistorySlice.reducer;
